import { FaCss3Alt, FaHtml5, FaNodeJs, FaReact } from 'react-icons/fa';
import { DiJavascript1 } from 'react-icons/di';
import { IoLogoNodejs } from 'react-icons/io';
import portfolio from '../../assets/images/projects/portfolio.png';
import resume from '../../assets/images/projects/resume.png';
import ecomm from '../../assets/images/projects/ecomm.png';
import crud from '../../assets/images/projects/crud.png';
import ecommreact from '../../assets/images/projects/ecomm-react.png';
import chat from '../../assets/images/projects/chat.png';
import dashboard from '../../assets/images/projects/dashboard.png';
import jsecomm from '../../assets/images/projects/js-ecomm.png';
import tea from '../../assets/images/projects/tea.png';
import travel from '../../assets/images/projects/travel.png';
import quiz from '../../assets/images/projects/quizapp.png';

const projectsData = [
  {
    id: 11,
    name: 'MERN Portfolio Website',
    tags: ['react-js', 'mern'],
    img: `${portfolio}`,
    desc: 'Personal MERN Stack Portfolio website with responsive and dynamic frontend. Frontend fetch data directly from mongoDB. It has custom Admin Panel where Admin can directly add, delete, update almost all the data of website like projects, experience, ,intro section, about, contact info directly without interfering with code. Note:- Deployed on free hosting, so it took some time to load',
    gitLink: 'https://github.com/omkrjha/mernportfolio',
    live: 'https://omkrjha.onrender.com/',
    tech: ['HTML', 'CSS', 'JavaScript', 'NodeJS', 'ReactJS'],
  },

  {
    id: 10,
    name: 'Resume Builder App',
    tags: ['react-js', 'mern'],
    img: `${resume}`,
    desc: 'An easy-to-use resume builder application, allowing users to create resumes quickly and efficiently React & Ant Design used for building a user-friendly interface with multiple resume templates. Implemented back-end functionality using NodeJS & Express, integrated the application with MongoDB for database storage. Note:- Deployed on free hosting, so it took some time to load',
    gitLink: 'https://github.com/omkrjha/resumebuilder',
    live: `https://mernresumebuilder.onrender.com/`,
    tech: [
      'HTML',
      'CSS',
      'JavaScript',
      'NodeJS',
      'ReactJS',
      'ExpressJS',
      'MongoDB',
    ],
  },
  {
    id: 9,
    name: 'MERN E-Commerce Web App',
    tags: ['mern', 'react-js'],
    img: `${ecomm}`,
    desc: 'Fully functional E-Commerce Web Application. Use React for responsive frontend, Redux for state management, Node & Express for server side functionality & MongoDB for database. Full featured shopping cart with PayPal & credit/debit payment. Admin area to manage customers, products & ordersProduct rating & review system Product search, carousel, pagination & more. Note:- Deployed on free hosting, so it took some time to load',
    gitLink: 'https://github.com/omkrjha/brocommerceapp',
    live: `https://broshop.onrender.com/`,
    tech: [
      'HTML',
      'CSS',
      'JavaScript',
      'ReactJS',
      'NodeJS',
      'ExpressJS',
      'MongoDB',
    ],
  },
  {
    id: 8,
    name: 'MERN Quiz App',
    tags: ['react-js', 'mern'],
    img: `${quiz}`,
    desc: 'Simple MERN Stack Quiz Application where Admin can add, delete Quiz exams, general user can register and take exams and check their scores, their results will be saved in backend which they can access through their account. Note:- Deployed on free hosting, so it took some time to load',
    gitLink: 'https://github.com/omkrjha/mernquizapp',
    live: `https://mernquizapplication.onrender.com/`,
    tech: [
      'HTML',
      'CSS',
      'JavaScript',
      'NodeJS',
      'ExpressJS',
      'MongoDB',
      'ReactJS',
    ],
  },
  {
    id: 7,
    name: 'MERN CRUD App',
    tags: ['mern', 'react-js'],
    img: `${crud}`,
    desc: "A simple MERN CRUD(Create Read Update Delete) Application, where use can read, add, delete, update user's data. For Frontend: ReactJS & Material-UI are used and for  Backend: NodeJS & ExpressJS, Database: MongoDB are used. Note:-Deployed on free hosting, so it took some time to load",
    gitLink: 'https://github.com/omkrjha/merncrudapp',
    live: `https://merncrudapplication.onrender.com`,
    tech: [
      'HTML',
      'CSS',
      'JavaScript',
      'ReactJS',
      'NodeJS',
      'ExpressJS',
      'MongoDB',
    ],
  },
  {
    id: 6,
    name: 'ReactJS E-Commerce App',
    tags: ['react-js'],
    img: `${ecommreact}`,
    desc: 'Developed a feature-rich e-commerce website using ReactJS ReactJS, JavaScript, RESTful API integration The website fetches product data from an external API and provides seamless filtering and sorting options. Implemented user authentication and authorization using Auth0 & deployed the application online',
    gitLink: 'https://github.com/omkrjha/reactecommerce',
    live: `https://ecommerce-react-web-app.netlify.app/`,
    tech: ['HTML', 'CSS', 'JavaScript', 'ReactJS'],
  },
  {
    id: 5,
    name: 'ReactJS Chat Application',
    tags: ['react-js'],
    img: `${chat}`,
    desc: 'A Real time Chat Web Application build using ReactJS for user friendly frontend, firebase used for handling user data, Login with Email and Password. User search functionality, user can send text and image using this applciation',
    gitLink: 'https://github.com/omkrjha/reactchatapp',
    live: `https://sandesh-app.netlify.app/`,
    tech: ['HTML', 'CSS', 'JavaScript', 'ReactJS'],
  },

  {
    id: 4,
    name: 'Multi-Theme Admin Dashboard',
    tags: ['react-js'],
    img: `${dashboard}`,
    desc: 'A simple Admin Dashboard build using ReactJS for frontend and apexcharts used here to create charts, graphs. This Admin Dashboard has Dark & Light mode with multiple color Themes options',
    gitLink: 'https://github.com/omkrjha/jsecommerce',
    live: `https://react-multi-theme-dashboard.netlify.app/`,
    tech: ['HTML', 'CSS', 'JavaScript', 'ReactJS'],
  },
  {
    id: 3,
    name: 'Vanilla JS E-Commerce',
    tags: ['javascript'],
    img: `${jsecomm}`,
    desc: 'A simple Multi Page Responsive Javascript E-Commerce Web Application build using only HTML, CSS and Javascript',
    gitLink: 'https://github.com/omkrjha/jsecommerce',
    live: `https://javascript-ecommerce-web-app.netlify.app/`,
    tech: ['HTML', 'CSS', 'JavaScript'],
  },
  {
    id: 2,
    name: 'Tour & Travel Website',
    tags: ['html-css'],
    img: `${tea}`,
    desc: 'Simple Tours & Travel App build with HTML & CSS Only',
    gitLink: 'https://github.com/omkrjha/backroadtourcompany',
    live: `https://tourstravels.netlify.app/`,
    tech: ['HTML', 'CSS'],
  },
  {
    id: 1,
    name: 'Tea Selling Website',
    tags: ['html-css'],
    img: `${travel}`,
    gitLink: 'https://github.com/omkrjha/TeaStationWebsite',
    live: 'https://tea-station-web-app.netlify.app/',
    desc: 'a tea selling website with responsive frontend made only with HTML & CSS, no external libraries used',
    tech: ['HTML', 'CSS'],
  },
];

export default projectsData;
